import { MessageInstance, NoticeType } from 'antd/es/message/interface'
import GoodIcon from 'assets/good.svg'
import { clsx } from 'clsx'
import { i18n } from 'i18n'
import { createElement, ReactElement } from 'react'
import { opt } from 'store/opt'
import { getNextKey } from 'util/id'
import css from './Notice.module.scss'

type Content = string | ReactElement

const DURATION = 3

let _api: MessageInstance

function getTypeClass(type: NoticeType) {
  if (type === 'warning') return css.info
  if (type === 'success') return css.success
  if (type === 'error') return css.error
}

function open(type: NoticeType, content: Content, icon?: ReactElement) {
  if (!_api) {
    if (typeof content === 'string') console.warn(`[${type}] `, content)
    return
  }
  const key = getNextKey()
  const duration = DURATION
  // На стенде экран большой и далеко — тост крупнее.
  const className = clsx(css.notice, getTypeClass(type), opt.basic && css.large)
  const onClick = () => _api.destroy(key)
  void _api.open({ key, type, content, className, duration, icon, onClick })
}

export function setMessageApi(api: MessageInstance): void {
  _api = api
}

export const notice = {
  info(content: Content): void {
    open('warning', content)
  },

  success(content?: Content | undefined): void {
    content = content || i18n('notice.Success')
    open('success', content, createElement('div', { className: css.icon }, createElement(GoodIcon)))
  },

  error(content?: Content): void {
    content = content || i18n('notice.Error')
    open('error', content)
  },
}
